import loadScript from '@xpeng/load-script';

export interface Weixin {
  config: (options: object) => void;
  ready: (callback: () => void) => void;
  error: (callback: (error: any) => void) => void;
  [key: string]: any;
}
export interface My {
  [key: string]: any;
}
export interface TT {
  [key: string]: any;
}
export interface Swan {
  [key: string]: any;
}

declare global {
  interface Window {
    wx: Weixin;
    my: My;
    tt: TT;
    swan: Swan;
  }
}

/**
 * @param {String} url
 * @returns
 */
function load(url: string): Promise<HTMLScriptElement> {
  return loadScript(url).catch(() => loadScript(url));
}

function noop(): void {}

/**
 * 微信 SDK 初始化的调用方法
 *
 * @returns {Promise<Weixin>}
 */
export function wxInit(): Promise<Weixin> {
  // 避免重复加载
  if (window.wx && typeof window.wx.config === 'function') {
    return Promise.resolve(window.wx);
  }

  // 非微信内置浏览器直接略过处理
  // 提供一个假的 wx 供全局调用避免异常
  if (!/MicroMessenger/gi.test(navigator.userAgent)) {
    const faker = { __isFaker: true };
    ['ready', 'config', 'error'].forEach(item => (faker[item] = noop));
    window.wx = faker as Weixin & { __isFaker: boolean };
    return Promise.resolve(window.wx);
  }

  // 加载 jssdk 后初始化
  return load('//res.wx.qq.com/open/js/jweixin-1.6.0.js').then(() =>
    Promise.resolve(window.wx)
  );
}

export function myInit(): Promise<My> {
  // 避免重复加载
  if (window.tt && typeof window.tt.miniProgram) {
    return Promise.resolve(window.tt);
  }

  // 加载 jssdk 后初始化
  return load('//appx/web-view.min.js').then(() => Promise.resolve(window.my));
}

export function ttInit(): Promise<TT> {
  // 避免重复加载
  if (window.tt && typeof window.tt.miniProgram) {
    return Promise.resolve(window.tt);
  }

  // 加载 jssdk 后初始化
  return load('//s.xiaopeng.com/xp-fe/mini/js/tt/jssdk-1.0.1.js').then(() =>
    Promise.resolve(window.tt)
  );
}

export function swanInit(): Promise<Swan> {
  // 避免重复加载
  if (window.swan && typeof window.swan.webView) {
    return Promise.resolve(window.swan);
  }

  // 加载 jssdk 后初始化
  return load('//s.xiaopeng.com/xp-fe/mini/js/swan/swan-2.0.22.js').then(() =>
    Promise.resolve(window.swan)
  );
}

export default {
  wxInit,
  myInit,
  ttInit,
  swanInit
};
